<template>
  <div>
    <vs-row class="mb-10">
      <vs-button
        @click="activeCreatePrompt = true"
        class="rounded-full"
        color="primary"
        icon-pack="feather"
        icon="icon-plus-circle"
        type="filled"
        >Добавить категорию</vs-button
      >
    </vs-row>
    <vx-card :title="`Список категорий | Всего ${totalCategories}`" class="p-6">
      <vs-table
        :data="categories"
        :stripe="true"
        :search="false"
        :pagination="false"
        :maxItems="20"
        noDataText="Элементов не найдено"
      >
        <template slot="thead">
          <vs-th> # </vs-th>
          <vs-th> Название </vs-th>
          <vs-th> Действия </vs-th>
        </template>

        <template slot-scope="{ data }">
          <vs-tr :key="indextr" v-for="(tr, indextr) in data">
            <vs-td :data="data[indextr].id">
              {{ data[indextr].id }}
            </vs-td>

            <vs-td :data="data[indextr].name">
              {{ data[indextr].name }}
            </vs-td>

            <vs-td>
              <vx-tooltip
                class="inline-block mr-5"
                text="Редактировать категорию"
              >
                <vs-button
                  @click="openEdit(data[indextr].id)"
                  color="dark"
                  class="text-dark"
                  icon-pack="feather"
                  icon="icon-edit"
                  size="large"
                  type="flat"
                ></vs-button>
              </vx-tooltip>
              <vx-tooltip class="inline-block" text="Удалить категорию">
                <vs-button
                  @click="deleteCategory(data[indextr].id)"
                  color="dark"
                  class="text-dark"
                  icon-pack="feather"
                  icon="icon-trash-2"
                  size="large"
                  type="flat"
                ></vs-button>
              </vx-tooltip>
            </vs-td>
          </vs-tr>
        </template>
      </vs-table>
      <vs-pagination
        class="mt-4"
        :total="totalPagePagination"
        v-model="currentPagingationPage"
      ></vs-pagination>
    </vx-card>

    <vs-popup title="Создание категории" :active.sync="activeCreatePrompt">
      <div class="loading-wrap vs-con-loading__container">
        <vs-input
          class="w-full mb-4"
          v-validate="'required'"
          data-vv-validate-on="blur"
          label="Название"
          name="Название"
          v-model="newCategory"
        />
        <span class="text-danger text-sm">{{ errors.first("Название") }}</span>

        <div class="popup-footer mt-4">
          <vs-button
            :disabled="!validateForm"
            @click="createCategory"
            class="mr-5"
            ref="loadableButton"
            type="relief"
            vslor="primary"
            >Создать</vs-button
          >
        </div>
      </div>
    </vs-popup>

    <vs-popup title="Редактирование категории" :active.sync="activeEditPrompt">
      <div class="loading-wrap vs-con-loading__container">
        <vs-input
          class="w-full mb-4"
          v-validate="'required'"
          data-vv-validate-on="blur"
          label="Название"
          name="Название"
          v-model="editCategory.name"
        />
        <span class="text-danger text-sm">{{ errors.first("Название") }}</span>

        <div class="popup-footer mt-4">
          <vs-button
            @click="updateCategory"
            class="mr-5"
            ref="loadableButton"
            type="relief"
            vslor="primary"
            >Обновить</vs-button
          >
        </div>
      </div>
    </vs-popup>
  </div>
</template>

<script>
import { API_URL } from "@/.env";

export default {
  data: () => ({
    BASE_URL: API_URL,

    categories: [],
    activeCreatePrompt: false,
    activeEditPrompt: false,
    newCategory: "",
    editCategory: [],

    currentPagingationPage: 1,
    totalCategories: 0,
    totalPagePagination: 1,
    countElements: 20,
  }),
  components: {},
  watch: {
    currentPagingationPage: function () {
      this.getEvents();
    },
  },
  computed: {
    validateForm() {
      return !this.errors.any() && this.newCategory !== "";
    },
  },
  methods: {
    notification(title, message, color) {
      this.$vs.notify({
        title: title,
        text: message,
        color: color,
        position: "top-center",
        time: "4000",
        icon: "delete",
      });
    },
    formatDate(date) {
      let now = new Date(date);

      let options = {
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
      };

      return now.toLocaleString("ru-ru", options);
    },

    getCategories() {
      let payload = {};

      payload.page =
        this.currentPagingationPage !== 1 ? this.currentPagingationPage : 1;

      this.$load(async () => {
        let res = (await this.$api.booking.getCategories(payload)).data;

        this.totalCategories = res.count;
        this.totalPagePagination = Math.ceil(
          this.totalCategories / this.countElements
        );

        this.categories = res.results;
      });
    },
    createCategory() {
      this.$load(async () => {
        let res = (
          await this.$api.booking.createCategory({ name: this.newCategory })
        ).data;

        this.notification("Успешно", "Категория создана", "success");

        this.categories.push(res);
        this.newCategory = "";
        this.activeCreatePrompt = false;
      });
    },
    openEdit(idCategory) {
      this.editCategory = this.categories.find((x) => x.id == idCategory);
      this.activeEditPrompt = true;
    },
    updateCategory() {
      this.$load(async () => {
        let res = (
          await this.$api.booking.updateCategory(this.editCategory.id, {
            name: this.editCategory.name,
          })
        ).data;

        this.notification("Успешно", "Категория обновлена", "success");

        this.editCategory = [];
        this.activeEditPrompt = false;
      });
    },
    deleteCategory(idCategory) {
      let item = this.categories.find((x) => x.id == idCategory),
        index = this.categories.indexOf(item);

      this.$load(async () => {
        let res = (await this.$api.booking.deleteCategory(idCategory)).data;

        if (index !== -1) {
          this.categories.splice(index, 1);
        }

        this.notification("Успешно", "Категория удалена", "success");
      });
    },
  },
  created() {},
  mounted() {
    this.getCategories();
  },
};
</script>